<template>
  <!-- 底部按钮 -->
  <div class="m-ft-btn">
    <div v-if="timeEndPage" class="ft-bg">
      <!-- 未登录 -->
      <div v-if="pageType == 0" class="ftwrap">
        <div class="left">
          <div class="t1">{{ timeLabel }}</div>
          <div class="t2">
            <v-mod-start-time :superInfo="superInfo" />
          </div>
        </div>
        <div class="right" @click="login">
          <div class="btn">请先登录</div>
        </div>
      </div>

      <!-- 报名中状态 已报名 -->
      <div v-if="pageType == 1" class="ftwrap">
        <div class="left">
          <div class="t1">{{ timeLabel }}</div>
          <div class="t2">
            <v-mod-start-time :superInfo="superInfo" />
          </div>
        </div>
        <div class="right" @click="handleAddPopup">
          <div class="btn">加buff券<span class="arr arr01">我已报名</span></div>
        </div>
      </div>

      <!-- 报名中状态 未报名 -->
      <div v-if="pageType == 2" class="ftwrap">
        <div class="left">
          <div class="t1">{{ timeLabel }}</div>
          <div class="t2">
            <v-mod-start-time :superInfo="superInfo" />
          </div>
        </div>
        <div class="right" @click="handleSignUp">
          <div class="btn">
            {{ superInfo.activityCategory == 2 ? "我要报名" : "0元抽" }}
            <span v-if="superInfo.preTaskEnabled" class="arr arr02 arr-desc">{{
              superInfo.preActivityDesc
            }}</span>
            <span
              v-if="
                !superInfo.preTaskEnabled && superInfo.limitedPopulation == 1
              "
              class="arr arr02"
              >芒果卡专享</span
            >
            <span
              v-if="
                !superInfo.preTaskEnabled && superInfo.limitedPopulation == 2
              "
              class="arr arr03"
              >推荐官专享</span
            >
          </div>
        </div>
      </div>

      <!-- 未开始 -->
      <div v-if="pageType == 3" class="ftwrap">
        <div class="left">
          <div class="t1">预告中，开始时间</div>
          <div class="t2">
            <v-mod-start-time
              :superInfo="superInfo"
              :typeTime="'signUpStartTime'"
            />
          </div>
        </div>
        <div
          v-if="this.superInfo.userInfo.appointmentRemind == 1"
          class="right"
        >
          <div class="btn btn-order">
            已预约
            <span v-if="superInfo.limitedPopulation == 1" class="arr arr02"
              >芒果卡专享</span
            >
            <span v-if="superInfo.limitedPopulation == 2" class="arr arr03"
              >推荐官专享</span
            >
          </div>
        </div>
        <div v-else class="right">
          <div class="btn" @click="handleOrder">
            正在预约
            <span v-if="superInfo.limitedPopulation == 1" class="arr arr02"
              >芒果卡专享</span
            >
            <span v-if="superInfo.limitedPopulation == 2" class="arr arr03"
              >推荐官专享</span
            >
          </div>
        </div>
      </div>

      <!-- 开奖中 已中奖 -->
      <div v-if="pageType == 4">
        <!-- 奖品 抽奖 -->
        <div
          v-if="
            superInfo.activityCategory == 1 ||
            (superInfo.activityCategory == 3 &&
              superInfo.userInfo.prizeType == 0)
          "
          class="ftwrap"
        >
          <div
            v-if="btnStatus == 4 || btnStatus == 5 || btnStatus == 6"
            class="left"
          >
            <div class="t3">抱歉，您暂未中奖</div>
            <div class="t1">是否申请候补?</div>
          </div>
          <div v-else class="left">
            <div class="t1">{{ timeLabel }}</div>
            <div class="t2">
              <v-mod-start-time :superInfo="superInfo" />
            </div>
          </div>

          <!-- 未确认 -->
          <div v-if="btnStatus == 1" class="right">
            <div class="btn btn-open" @click="handleOpenGift">
              已中奖待确认<span class="arr"
                >待确认<van-count-down
                  v-if="openGiftCountDownTime > 0"
                  :time="openGiftCountDownTime"
                  format="mm:ss"
                  @finish="finishPage('gift')"
              /></span>
            </div>
          </div>

          <!-- 已确认 -->
          <div v-if="btnStatus == 2" class="right">
            <div
              class="btn"
              @click="handleToast('已确认成功，请等待短信或客服的出票通知')"
            >
              已确认领取
            </div>
          </div>

          <!-- 已放弃 -->
          <div v-if="btnStatus == 3" class="right">
            <div
              class="btn btn-giveup"
              @click="handleToast('已放弃，还有机会参加其他活动')"
            >
              已确认放弃
            </div>
          </div>

          <!-- 未中奖 -->
          <div v-if="btnStatus == 4" class="right">
            <div class="btn" @click="handleContinue">
              申请候补
              <span class="arr"
                >候补截止<van-count-down
                  v-if="openGiftCountDownTime > 0"
                  :time="openGiftCountDownTime"
                  format="mm:ss"
                  @finish="finishPage('gift')"
              /></span>
            </div>
          </div>

          <!-- 候补成功，候补中 -->
          <div
            v-if="
              btnStatus == 5 ||
              btnStatus == 6 ||
              btnStatus == 11 ||
              btnStatus == 10
            "
            class="right"
          >
            <div
              class="btn"
              @click="handleToast('请等待候补公示后，页面中奖信息')"
            >
              已提交候补
              <span class="arr"
                >候补公示<van-count-down
                  v-if="openGiftCountDownTime > 0"
                  :time="openGiftCountDownTime"
                  format="mm:ss"
                  @finish="finishPage('gift')"
              /></span>
            </div>
          </div>

          <!-- 候补成功，候补中 -->
          <div v-if="btnStatus == 8" class="right">
            <div class="btn btn-order">候补成功</div>
          </div>

          <!-- 候补-待提交-盲盒 -->
          <div v-if="btnStatus == 9" class="right">
            <div class="btn btn-blind" @click="handleBlind">
              <div class="t1">候补成功</div>
              <div class="t2">请立即填写相关信息</div>
            </div>
          </div>

          <!-- 候补-未在规定时间提交-盲盒 -->
          <div v-if="btnStatus == 12" class="right">
            <div class="btn btn-blind btn-blind-fail">
              <div class="t1">候补失败</div>
              <div class="t2">未在规定时间内提交信息</div>
            </div>
          </div>

          <!--  未报名，显示已结束 -->
          <div
            v-if="btnStatus == 7"
            class="right"
            @click="handleToast('已结束，请参与其他活动吧')"
          >
            <div class="btn btn-end">报名已截止，开奖中</div>
          </div>
        </div>

        <!-- 榜单 抽奖 -->
        <div
          v-if="
            superInfo.activityCategory == 2 ||
            (superInfo.activityCategory == 3 &&
              superInfo.userInfo.prizeType == 1)
          "
          class="ftwrap"
        >
          <div class="left">
            <div class="t1">{{ timeLabel }}</div>
            <div class="t2">
              <v-mod-start-time :superInfo="superInfo" />
            </div>
          </div>

          <!-- 榜单 已中奖 未确认 -->
          <div v-if="btnStatus == 1" class="right">
            <!-- 门票 -->
            <div v-if="superInfo.prizeType == 1" class="btn btn-order">
              已获奖励
            </div>
            <!-- 芒盒奖品 -->
            <div
              v-if="superInfo.prizeType == 2"
              class="btn btn-blind"
              @click="handleBlind"
            >
              <div class="t1">已获奖励</div>
              <div class="t2">请立即填写相关信息</div>
            </div>
          </div>

          <!-- 榜单 已中奖 已确认 -->
          <div v-if="btnStatus == 2" class="right">
            <!-- 门票或者芒盒奖品 -->
            <div class="btn btn-order">已获奖励</div>
          </div>

          <!-- 未中奖 榜单 -->
          <div v-if="btnStatus == 4" class="right">
            <div class="btn btn-end">报名已截止，开奖中</div>
          </div>
        </div>
      </div>

      <!-- 已结束 -->
      <div v-if="pageType == 5" class="ftwrap">
        <div class="left">
          <div class="t1">{{ timeLabel }}</div>
          <div class="t2">
            <v-mod-start-time :superInfo="superInfo" />
          </div>
        </div>

        <!-- 榜单 已中奖 已确认 -->
        <div
          v-if="superInfo.activityCategory == 2 && btnStatus == 2"
          class="right"
        >
          <div class="btn btn-order">
            {{ superInfo.userInfo.prizeType == 1 ? "已获奖励" : "已中奖" }}
          </div>
        </div>

        <!-- 榜单 已中奖 未确认 -->
        <div
          v-else-if="superInfo.activityCategory == 2 && btnStatus == 1"
          class="right"
        >
          <div v-if="superInfo.prizeType == 1" class="btn btn-order">
            已获奖励
          </div>

          <div
            v-if="superInfo.prizeType == 2"
            class="btn btn-blind"
            @click="handleBlind"
          >
            <div class="t1">已获奖励</div>
            <div class="t2">请立即填写相关信息</div>
          </div>
        </div>

        <!-- 已中奖 已确认 -->
        <div
          v-else-if="superInfo.activityCategory == 1 && btnStatus == 2"
          class="right"
        >
          <div class="btn btn-order">已中奖</div>
        </div>

        <!-- 榜单+奖品 已中奖 已确认 -->
        <div
          v-else-if="superInfo.activityCategory == 3 && btnStatus == 2"
          class="right"
        >
          <div class="btn btn-order">
            {{ superInfo.userInfo.prizeType == 1 ? "已获奖励" : "已中奖" }}
          </div>
        </div>

        <!-- 榜单+奖品 已中奖 未确认 -->
        <div
          v-else-if="superInfo.activityCategory == 3 && btnStatus == 1"
          class="right"
        >
          <div v-if="superInfo.userInfo.prizeType == 1">
            <div v-if="superInfo.prizeType == 1" class="btn btn-order">
              已获奖励
            </div>
            <div
              v-if="superInfo.prizeType == 2"
              class="btn btn-blind"
              @click="handleBlind"
            >
              <div class="t1">已获奖励</div>
              <div class="t2">请立即填写相关信息</div>
            </div>
          </div>
          <div v-else>
            <div class="btn btn-order">
              {{ superInfo.prizeType == 1 ? "已中奖" : "报名已截止" }}
            </div>
          </div>
        </div>

        <!-- 已中奖 -->
        <div v-else-if="btnStatus == 5" class="right">
          <div class="btn btn-order">候补成功</div>
        </div>

        <!-- 已提交候补，候补失败 -->
        <div v-else-if="btnStatus == 6" class="right">
          <div class="btn btn-order">未中奖</div>
        </div>

        <!-- 候补-待提交-盲盒 -->
        <div v-else-if="btnStatus == 11" class="right">
          <div class="btn btn-blind" @click="handleBlind">
            <div class="t1">候补成功</div>
            <div class="t2">请立即填写相关信息</div>
          </div>
        </div>

        <!-- 候补-未在规定时间提交-盲盒 -->
        <div v-else-if="btnStatus == 10" class="right">
          <div class="btn btn-blind btn-blind-fail">
            <div class="t1">候补失败</div>
            <div class="t2">未在规定时间内提交信息</div>
          </div>
        </div>

        <div
          v-else
          class="right"
          @click="handleToast('已结束，请参与其他活动吧')"
        >
          <div
            v-if="
              superInfo.activityCategory == 2 &&
              superInfo.userInfo.userSignupStatus == 1
            "
            class="btn btn-end"
          >
            本轮活动已结束
          </div>
          <div v-else class="btn btn-end">报名已截止</div>
        </div>
      </div>

      <!-- 倒计时开奖 -->
      <div v-if="pageCountDownTime > 0" class="page-count-down">
        <van-count-down
          @finish="finishPage('page')"
          :time="pageCountDownTime"
        />
      </div>
    </div>

    <div v-else class="ft-bg">
      <!-- 倒计时结束，查询结果 状态-->
      <div class="ftwrap">
        <div class="left">
          <div class="t1">{{ timeLabel }}</div>
          <div class="t2">
            <v-mod-start-time :superInfo="superInfo" />
          </div>
        </div>
        <div class="right" @click="handlerRefresh">
          <div class="btn">查询结果</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { login } from "@utils/login";
// import { Image as VanImage } from "vant";
import { Toast, CountDown as VanCountDown } from "vant";
import { jumpPage, getQuery } from "@utils/url";
import VModStartTime from "@components/v-mod-start-time.vue";
import service from "@utils/service.js";
import { statClick } from "@utils/h5-report";

export default {
  name: "MCard",

  data() {
    return {
      pageCountDownTime: 0, // 倒计时 - 开奖结束
      openGiftCountDownTime: 0, // 倒计时 - 领奖确认结束
      drawEndCountDownTime: 0, // 倒计时 - 开奖及候补
      btnStatus: 0,
      superId: getQuery("superId") || "",
      timeEndPage: this.isSearching,
      refreshName: "",
    };
  },
  components: { VanCountDown, VModStartTime },

  props: {
    superInfo: {
      type: Object,
      default: () => {},
    },
    actInfo: {
      type: Object,
      default: () => {},
    },
    // 是否芒果卡用户 0否, 1是
    isHit: {
      type: [String, Number],
      default: () => "0",
    },
    // 是否在展示查询结果
    isSearching: {
      type: Boolean,
      default: () => true,
    },
  },
  watch: {
    isSearching: {
      handler() {
        this.timeEndPage = true;
      },
    },
  },
  computed: {
    ...mapState(["userInfo", "identity"]),
    // 获取时间文案
    timeLabel() {
      const { activityCategory } = this.superInfo;
      if (activityCategory == 2) {
        if (this.pageType == 1) {
          return "榜单截止时间";
        }
        return "榜单公示时间";
      }
      if (activityCategory == 3) {
        if (this.pageType == 2) {
          return "开奖时间";
        }
        if (this.pageType == 5) {
          const excludeStatus = [2, 5, 6, 11, 10];
          if (!excludeStatus.includes(this.btnStatus)) {
            return "开奖时间";
          }
        }
        return "开奖及榜单公示时间";
      }
      return "开奖时间";
    },
    // 用户状态
    pageType() {
      const {
        activityCurrentStatus,
        userInfo: { userSignupStatus },
      } = this.superInfo;
      // 未登录
      if (!this.userInfo.uuid) {
        // 即将报名
        if (activityCurrentStatus == 0) {
          return 3;
        }
        return 0;
      } else {
        // 报名中 已报名
        if (userSignupStatus == 1 && activityCurrentStatus == 1) {
          return 1;
        }
        // 报名中 未报名
        if (userSignupStatus == 0 && activityCurrentStatus == 1) {
          return 2;
        }
        // 即将报名
        if (activityCurrentStatus == 0) {
          return 3;
        }
        // 开奖中
        if (activityCurrentStatus == 2 || activityCurrentStatus == 3) {
          this.openGiftStatus("open"); // 开奖逻辑
          return 4;
        }
        // 已结束
        if (activityCurrentStatus == 4) {
          this.openGiftStatus(); // 开奖逻辑
          return 5;
        }
      }
      // 默认情况
      return -1;
    },
  },
  mounted() {
    this.countdownOpenGift();
  },

  methods: {
    // 倒计时开奖
    countdownOpenGift() {
      if (!this.userInfo.uuid) {
        return;
      }
      this.pageCountDownTime = this.setCdTime(
        this.superInfo.now,
        this.superInfo.drawStartTime,
      );
    },

    // 倒计时开奖
    finishPage(name) {
      this.refreshName = name;
      // 查询结果页面 开奖中，用户已报名
      if (
        name == "page" &&
        this.superInfo.activityCurrentStatus == 1 &&
        this.superInfo.userInfo.userSignupStatus == 1
      ) {
        this.timeEndPage = false;
      }
      if (name == "gift") {
        this.timeEndPage = false;
      }
    },

    // 查询结果按钮，刷新页面
    handlerRefresh() {
      this.$emit("refresh", this.refreshName);
    },

    // 登录
    login() {
      // 数据上报
      statClick(
        {
          actid: this.superId,
          identity: this.identity,
        },
        {
          cont: "点击登录",
          mod: "login",
        },
      );
      // 跳转登录页面
      if (!this.userInfo.uuid) {
        setTimeout(() => {
          login(async () => {
            window.location.reload();
          });
        }, 300);
      }
    },
    // 跳转
    handleJump(url) {
      jumpPage(url);
    },

    // 添加奖券弹窗
    handleAddPopup() {
      // 数据上报
      statClick(
        {
          actid: this.superId,
          identity: this.identity,
        },
        {
          cont: "点击添加奖券",
          mod: "add_lottery_tickets",
        },
      );
      if (this.superInfo.userInfo.myRemainingTicketCount < 1) {
        Toast("做任务获得buff券吧");
        const labelScroll = document.querySelector(`#setAnchor`);
        if (labelScroll) {
          window.scrollTo({
            top: labelScroll.offsetTop - 300,
            behavior: "smooth",
          });
        }
        return;
      }
      this.$emit("handleAddPopup");
    },

    // 检查身份限制并跳转
    checkIdentityAndJump() {
      const {
        limitedPopulation,
        userInfo: { userIdentity },
      } = this.superInfo;
      const { isHit, actInfo } = this;

      // 定义身份限制映射
      const identityMap = {
        // 身份限制为芒果卡
        1: {
          type: "mgCard",
          url: actInfo.url1,
          condition: userIdentity == 0 && isHit == 0,
          isHit,
        },
        // 身份限制为推荐官
        2: {
          type: "mgOffi",
          url: isHit == 1 ? actInfo.url2 : actInfo.url1,
          condition: userIdentity == 0,
          isHit,
        },
      };
      // 检查身份限制并跳转
      if (identityMap[limitedPopulation]) {
        const { url, condition, type, isHit } = identityMap[limitedPopulation];
        if (condition) {
          this.$emit("handleJumpPopup", { url, type, isHit });
          return true; // 表示已跳转
        }
      }
      return false; // 表示未跳转
    },

    // 检查是否有抽奖机会
    checkDrawChance() {
      const {
        preTaskEnabled,
        preTaskDesc,
        preTaskBtnText,
        preTaskUrl,
        userInfo: { enabledDraw },
      } = this.superInfo;
      if (preTaskEnabled) {
        if (!enabledDraw) {
          this.$emit("handleJumpPopup", {
            type: "preTask",
            text: preTaskDesc,
            btnText: preTaskBtnText,
            url: preTaskUrl,
          });
          return false;
        }
      }
      return true;
    },
    // 报名
    handleSignUp() {
      // 数据上报
      statClick(
        {
          actid: this.superId,
          identity: this.identity,
        },
        {
          cont: "点击我要报名",
          mod: "my_poster",
        },
      );
      // 检查是否有抽奖机会
      if (!this.checkDrawChance()) {
        return;
      }
      // 检查身份限制并跳转
      if (this.checkIdentityAndJump()) {
        return;
      }

      // 展示报名弹窗
      this.$emit("showSignUpPopup");
    },

    // 预约 活动开始
    async handleOrder() {
      // 数据上报
      statClick(
        {
          actid: this.superId,
          identity: this.identity,
        },
        {
          cont: "点击预约提醒",
          mod: "appointment_reminder",
        },
      );
      // 跳转登录页面
      if (!this.userInfo.uuid) {
        setTimeout(() => {
          login(async () => {
            window.location.reload();
          });
        }, 300);
        return;
      }
      // 检查身份限制并跳转
      if (this.checkIdentityAndJump()) {
        return;
      }

      let params = {
        activityId: this.superId,
        ticket: this.userInfo.ticket,
        type: 1,
      };
      const res = await service.setSubscription(params);
      if (res.errno === "0") {
        Toast("预约成功");
        this.$emit("refresh");
      } else {
        Toast(res.msg || "设置失败");
      }
    },

    // 开奖状态逻辑
    openGiftStatus(status) {
      const { prizeStatus, confirmState, userSignupStatus } =
        this.superInfo.userInfo;
      // 如果未报名，直接设置状态为活动结束
      if (userSignupStatus !== 1) {
        if (status == "open") {
          this.btnStatus = 7; // 报名已截止，开奖中
        }
        return;
      }
      // 预先计算倒计时时间，避免重复计算
      const countDownTime = this.setCdTime(
        this.superInfo.now,
        this.superInfo.drawEndTime,
      );
      // 已报名
      // 已中奖未确认
      if (prizeStatus == 1 && confirmState == 0) {
        this.btnStatus = 1;
        this.openGiftCountDownTime = countDownTime;
      }
      // 已中奖已确认
      if (prizeStatus == 1 && confirmState == 1) {
        this.btnStatus = 2;
      }
      // 已放弃
      if (prizeStatus == 2) {
        this.btnStatus = 3;
      }
      // 未中奖
      if (prizeStatus == 0) {
        this.openGiftCountDownTime = countDownTime;
        // 开奖完成，倒计时结束，未中奖
        if (status == "open" && this.openGiftCountDownTime < 1) {
          this.btnStatus = 7; // 本轮活动已结束
        } else {
          this.btnStatus = 4; // 申请候补 有倒计时
        }
      }
      // 候补成功
      if (prizeStatus == 3) {
        this.openGiftCountDownTime = countDownTime;
        // 开奖完成，倒计时结束，候补成功
        if (status == "open" && this.openGiftCountDownTime < 1) {
          this.btnStatus = 8; // 显示候补成功
        } else {
          this.btnStatus = 5; // 已提交候补 有倒计时
        }
      }
      // 候补中
      if (prizeStatus == 4) {
        this.openGiftCountDownTime = countDownTime;
        // 开奖完成，倒计时结束，候补失败
        if (status == "open" && this.openGiftCountDownTime < 1) {
          this.btnStatus = 7; // 报名已截止
        } else {
          this.btnStatus = 6; // 已提交候补 有倒计时
        }
      }
      // 候补成功-填写信息
      if (prizeStatus == 5) {
        this.openGiftCountDownTime = countDownTime;
        // 开奖完成，倒计时结束，候补失败
        if (status == "open" && this.openGiftCountDownTime < 1) {
          this.btnStatus = 9; // 候补-待提交
        } else {
          this.btnStatus = 11; // 候补-待提交 有倒计时
        }
      }
      // 候补失败-未在规定时间提交
      if (prizeStatus == 6) {
        this.openGiftCountDownTime = countDownTime;
        // 开奖完成，倒计时结束，候补失败
        if (status == "open" && this.openGiftCountDownTime < 1) {
          this.btnStatus = 12; // 候补-待提交
        } else {
          this.btnStatus = 10; // 已提交候补 有倒计时
        }
      }
    },

    // 获取倒计时-时间戳
    setCdTime(now, time) {
      if (!time) {
        return 0;
      }
      const sysTime = now;
      // 转换字符串为Date对象
      const sysDateNew = new Date(sysTime.replace(/-/g, "/"));
      const compareDateNew = new Date(time.replace(/-/g, "/"));
      // 获取毫秒数
      const sysTimestamp = sysDateNew.getTime();
      const compareTimestamp = compareDateNew.getTime();
      // 计算毫秒差值
      const diffMilliseconds = compareTimestamp - sysTimestamp;
      if (diffMilliseconds > 0) {
        return diffMilliseconds;
      }
      return 0;
    },

    // 确认领取
    handleOpenGift() {
      // 数据上报
      statClick(
        {
          actid: this.superId,
          identity: this.identity,
        },
        {
          cont: "点击确认领取",
          mod: "confirm_get",
        },
      );
      this.$emit("handleOpenGift");
    },

    // 申请候补
    handleContinue() {
      // 数据上报
      statClick(
        {
          actid: this.superId,
          identity: this.identity,
        },
        {
          cont: "点击申请候补",
          mod: "apply_backup",
        },
      );
      this.$emit("handleContinue");
    },

    // 结束
    handleToast(msg) {
      Toast(msg);
    },

    // 盲盒，填写信息
    handleBlind() {
      this.$emit("handleBlind");
    },
  },
};
</script>

<style lang="less">
.m-ft-btn {
  position: fixed;
  bottom: 0;
  left: 50%;
  z-index: 50;
  width: 100%;
  max-width: 375px;
  margin-left: -187.5px;
  color: #000;
  box-sizing: border-box;
  .ft-bg {
    width: 100%;
    height: 111px;
    box-sizing: border-box;
    background-image: url("../assets/image/ft-btn-bg.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center top;
  }
  .ftwrap {
    width: 320px;
    margin: 0 auto;
    padding-top: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    .left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      width: 130px;
      height: 50px;
      text-align: left;
      .t1 {
        font-weight: 600;
        font-size: 13px;
        color: rgba(0, 0, 0, 0.5);
      }
      .t2 {
        font-weight: 600;
        font-size: 15px;
        color: #001a33;
        // span {
        //   font-size: 13px;
        // }
      }
      .t3 {
        font-weight: 600;
        font-size: 15px;
        color: rgba(0, 0, 0, 0.8);
      }
    }
    .right {
      .btn {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 130px;
        height: 43px;
        margin: 0 auto;
        font-weight: 800;
        font-size: 17px;
        color: #001a33;
        background-image: url("../assets/image/ft-btn-icon01.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center top;
        .arr {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          right: 15px;
          top: -8px;
          // width: 76px;
          height: 16px;
          padding: 0 10px;
          font-weight: 400;
          font-size: 10px;
          color: rgba(18, 18, 18, 0.8);
          background: linear-gradient(90deg, #0fffdb 0%, #a3f39b 100%);
          border-radius: 8px;
        }
        .arr01 {
          background: linear-gradient(90deg, #c0ff66 0%, #fffb00 100%);
        }
        .arr02 {
          background: linear-gradient(90deg, #ffdf17 0%, #ffab6f 100%);
        }
        .arr03 {
          top: -15px;
          width: 88.5px;
          height: 22px;
          text-indent: -9999px;
          background-image: url("../assets/image/ft-btn-arr01.png");
          background-repeat: no-repeat;
          background-size: 100% auto;
          background-position: center top;
        }
        .arr-desc {
          overflow: hidden;
          align-items: start;
          max-width: 90px;
          line-height: 16px;
        }
      }
      .btn-end {
        width: 184px;
        color: rgba(0, 26, 51, 0.4);
        background-image: url("../assets/image/ft-btn-icon02.png");
      }
      .btn-giveup {
        width: 148px;
        color: rgba(0, 26, 51, 0.4);
        background-image: url("../assets/image/ft-btn-icon03.png");
      }
      .btn-open {
        width: 166px;
        background-image: url("../assets/image/ft-btn-icon04.png");
      }
      .btn-blind-fail {
        width: 130px;
        background-image: url("../assets/image/ft-btn-icon05.png");
      }
      .van-count-down {
        font-size: 10px;
        color: rgba(18, 18, 18, 0.8);
      }
      .btn-order {
        opacity: 0.5;
      }
      .btn-blind {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .t1 {
          font-size: 15px;
          font-weight: 800;
          color: #001a33;
        }
        .t2 {
          font-size: 10px;
          font-weight: 400;
          font-size: 9px;
          color: rgba(0, 26, 51, 0.7);
        }
      }
      .btn-blind-fail {
        .t1 {
          color: rgba(0, 26, 51, 0.4);
        }
        .t2 {
          color: rgba(0, 26, 51, 0.3);
        }
      }
    }
  }
  .page-count-down {
    display: none;
  }
}
</style>
